<button sb-button [sbDropdownToggle]="groupByMenu" [sbDropdownPlacement]="'bottom-right'">
  <sb-icon [name]="'list-check-3-regular'" />
  {{ 'Group by' | translate }}
  <sb-icon [name]="'down-regular'" iconPositionEnd />
</button>
<ng-template #groupByMenu>
  <div sbDropdownMenu>
    @for (radioGroup of radioGroups(); track radioGroup.groupId; let i = $index) {
      <span class="mb-2 ml-2 text-support">{{ radioGroup.groupLabel | translate }}</span>
      @for (option of radioGroup.options; track option.key) {
        <!-- TODO sbDropdownItemTriggered is needed because otherwise clicking anywhere outside of the input or label (but still within the dropdown item) would not select the option. Probably want to introduce a sbDropdownRadioItem sometime in the future to properly handle this-->
        <div
          class="flex items-center justify-start gap-2"
          sbDropdownItem
          sbDropdownItemKeepOpenOnTrigger
          (sbDropdownItemTriggered)="radioGroup.formControl.setValue(option.key)"
        >
          <input
            type="radio"
            class="cursor-pointer"
            [id]="radioGroup.groupId + '_' + option.key"
            [name]="radioGroup.groupId"
            [value]="option.key"
            [formControl]="radioGroup.formControl"
          />
          <label class="cursor-pointer" [for]="radioGroup.groupId + '_' + option.key">{{
            option.value | translate
          }}</label>
        </div>
      }
      @if (i < radioGroups.length - 1) {
        <div sbDropdownDivider></div>
      }
    }
  </div>
</ng-template>
